// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bp5-table-menu {
  background-color: var(--bp-light-gray4);
  box-shadow: 1px 0 var(--bp-light-gray4);
  border-bottom: 1px solid var(--bp-light-gray1);
}

.bp5-table-menu {
  height: var(--header-height) !important;
}

.small_font .bp5-table-menu {
  height: var(--short-header-height) !important;
}

.bp5-table-truncated-text {
  height: 100%;
  align-content: center;
}

.bp5-table-cell-interactive {
  z-index: unset;
}

.bp5-portal {
  margin: 10px;
}

.bp5-popover-transition-container.bp5-overlay-content {
  transition-delay: 200ms;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/AdvancedDataTable/DataTable.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".bp5-table-menu {\n  background-color: var(--bp-light-gray4);\n  box-shadow: 1px 0 var(--bp-light-gray4);\n  border-bottom: 1px solid var(--bp-light-gray1);\n}\n\n.bp5-table-menu {\n  height: var(--header-height) !important;\n}\n\n.small_font .bp5-table-menu {\n  height: var(--short-header-height) !important;\n}\n\n.bp5-table-truncated-text {\n  height: 100%;\n  align-content: center;\n}\n\n.bp5-table-cell-interactive {\n  z-index: unset;\n}\n\n.bp5-portal {\n  margin: 10px;\n}\n\n.bp5-popover-transition-container.bp5-overlay-content {\n  transition-delay: 200ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
